import { useScreen } from '@/hooks/useScreen';
import Box from '@mui/material/Box';
import { useEffect, useRef, useState } from 'react';
import TabsCustomized from '../../../tabs/TabsCustomized';

interface ISwitchTabProfile {
  matches: boolean;
  enumPage: number;
  setEnumPage: Function;
}

const SwitchTabProfile = ({
  matches,
  enumPage,
  setEnumPage,
}: ISwitchTabProfile) => {
  const tabRef = useRef<HTMLDivElement>(null);
  const [isSticky, setIsSticky] = useState<boolean>(false);
  const { isMobile } = useScreen();

  const profileLayoutHeaderHeight = isMobile ? 54 : 50;

  // // mount
  useEffect(() => {
    const cachedRef = tabRef.current as Element,
      observer = new IntersectionObserver(
        ([e]) => {
          setIsSticky(e.intersectionRatio < 1);
        },
        {
          threshold: [1],
          rootMargin: `-${
            Math.ceil(profileLayoutHeaderHeight) + 1
          }px 0px 0px 0px`,
        }
      );

    observer.observe(cachedRef);

    // unmount
    return function () {
      observer.unobserve(cachedRef);
    };
  }, [profileLayoutHeaderHeight, tabRef]);

  return (
    <div
      style={{
        top: profileLayoutHeaderHeight,
      }}
      className={[
        'sticky z-[9] mb-[30px] w-full',
        !isSticky ? 'bg-transparent' : 'bg-white',
      ].join(' ')}
    >
      <div ref={tabRef} className="h-full w-full">
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            width: '100%',
            backgroundColor: 'transparent',
            marginBottom: !isSticky ? '30px' : 0,
          }}
        >
          <TabsCustomized
            value={enumPage}
            handleChange={(_e: unknown, value: number) => setEnumPage(value)}
            tabList={
              matches
                ? ['Tường nhà', 'Hồ sơ']
                : ['Tường nhà', 'Hồ sơ', 'Liên hệ']
            }
            tabClassname={`${!matches ? '!flex-1' : ''}`}
          />
        </Box>
      </div>
    </div>
  );
};

export default SwitchTabProfile;
